<template><div><h1 id="zahlungsmodi" tabindex="-1"><a class="header-anchor" href="#zahlungsmodi"><span>Zahlungsmodi</span></a></h1>
<p>Zahlungsmodi — Definiert den Zahlungsmodus von Zusagen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die Zahlungsmodi wie z.B. LSV, BAD, etc. ESR-Zahlung wird als Standard vorausgesetzt und ist nicht extra aufgeführt. Die Zahlungsmodi sollten nur durch ARENAE Consulting AG verändert werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Zahlungsmodi</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Modus</dt>
<dd>Code</dd>
<dt>Beschreibung</dt>
<dd>Freier Text für Beschreibung.</dd>
<dt>FTML-Data/Payment</dt>
<dd>Wert &quot;PaymentType&quot; aus <a class="link" href="../../manual/schnittstelle/ftml.html" title="4. FTML (E-Commerce)">FTML</a>. Der PaymentType aus der FTML-Transaktion kann so einem Zahlungsmodus zugeordnet werden.</dd>
<dt>Erkennungsmerkmal</dt>
<dd>Zusätzliches Attribut, neben dem &quot;PaymentType&quot;, für ein differenziertes Mapping. So kann z.B. ein &quot;PaymentType&quot; wie &quot;extern&quot;, in verschiedenen Schnittstellen vorkommen. Mit dem Erkennungsmerkmal kann die Zahlungsmodus-Zuordnung auf bestimmte Transaktionen eingeschränkt werden (z.B. Erkennungsmerkmal &quot;RaiseNow&quot; für RaiseNow-Transaktionen).</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/ftml.html" title="4. FTML (E-Commerce)">FTML (E-Commerce)</RouteLink></p>
</div></template>


